import { TopicInfo } from '../../topic-list-view/TopicListItemView'

export interface EventHit {
  id: number,
  public_id?: number,
  content_type: 'event',
  objectID: string,
  title: string,
  description: string,
  starts_at: number,
  ends_at: number,
  source: 'community',
  type?: string,
  image?: string,
  location?: string,
  topic_url: string,
  url?: string,
  _highlightResult?: object
}

export interface Hit {
  id: number,
  public_id?: number,
  objectID: string,
  topic_url: string,
  url: string,
  title: string,
  forum: number,
  forum_title: string,
  source: CommunitySourceType,
  content_type: TopicContentType,
  category_id: number,
  category_title: string,
  has_answer: boolean,
  article_label: string
  _highlightResult?: object
}

export interface ZendeskHit {
  objectID: string,
  title: string,
  url: string,
  topic_url?: string,
  source: 'zendesk',
  content: string,
  _highlightResult: string
}

export interface SalesforceHit {
  objectID: string,
  title: string,
  url: string,
  topic_url?: string,
  source: 'salesforce',
  content: string,
  _highlightResult: string
}

export interface SkilljarHit {
  objectID: string,
  title: string,
  url: string,
  topic_url?: string,
  source: 'skilljar',
  content: string,
  _highlightResult: string
}

export interface FreshdeskHit {
  objectID: string,
  title: string,
  url: string,
  topic_url?: string,
  source: 'freshdesk',
  content: string,
  _highlightResult: string
}

export function isCommunityResult (el: EventHit | Hit | ZendeskHit | SalesforceHit | SkilljarHit | FreshdeskHit): el is Hit | EventHit {
  return !isZendeskResult(el) && !isSalesforceResult(el) && !isSkilljarResult(el) && !isFreshdeskResult(el)
}

export function isCommunityResultEvent (el: EventHit | Hit | TopicInfo): el is EventHit {
  return el.content_type === 'event'
}

export function isZendeskResult (el: EventHit | Hit | ZendeskHit | SalesforceHit | SkilljarHit | FreshdeskHit): el is ZendeskHit {
  return el.source === 'zendesk'
}

export function isSalesforceResult (el: EventHit | Hit | ZendeskHit | SalesforceHit | SkilljarHit | FreshdeskHit): el is SalesforceHit {
  return el.source === 'salesforce'
}

export function isSkilljarResult (el: EventHit | Hit | ZendeskHit | SalesforceHit | SkilljarHit | FreshdeskHit): el is SkilljarHit {
  return el.source === 'skilljar'
}

export function isFreshdeskResult (el: EventHit | Hit | ZendeskHit | SalesforceHit | SkilljarHit | FreshdeskHit): el is FreshdeskHit {
  return el.source === 'freshdesk'
}

export type SearchType = 'zendesk' | 'community' | 'salesforce' | 'skilljar' | 'freshdesk'

export interface DoSearch {
  (input: string): void
}

export interface GetItemPropsFn {
  (data: {item: EventHit|Hit|ZendeskHit|SalesforceHit|SkilljarHit|FreshdeskHit, index: number}): {}
}

export interface SearchResults {
  hitsPerPage: number,
  page: number,
  queryID: string,
  nbHits: number,
  hits: Array<EventHit|Hit|ZendeskHit|SalesforceHit|SkilljarHit|FreshdeskHit>,
  nbPages: number,
  query: string
}

export type AllSearchResults = {
  [index: string]: SearchResults | undefined
}

export interface TopicClickedEvent {
  type: string,
  topic_url: string,
  click_source: string,
  topic_position: number,
  topic_title: string,
  topic_topic_type: string,
  category_id?: number,
  category_title?: string,
}


export interface TopicClickedGoogleAnalyticsEvent {
    eventCategory: 'Live Search',
    eventAction: 'Topic Clicked',
    eventLabel: {
      Link: string,
      Position: number,
      Type: SearchType | TopicContentType
    }
}
